var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 22,
    viewBox: "0 0 143 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9584 0.97937H4.19141V5.17937H20.9584V0.97937Z",
    fill: "#1C6947"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.767 17.7794H0V21.9794H16.767V17.7794Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7667 9.37939H4.19141V13.5794H16.7667V9.37939Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9584 13.5793H16.7666V17.7793H20.9584V13.5793Z",
    fill: "#1C6947"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19175 13.5793H0V17.7793H4.19175V13.5793Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19175 5.17932H0V9.37932H4.19175V5.17932Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9584 5.17932H16.7666V9.37932H20.9584V5.17932Z",
    fill: "#1C6947"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8928 9.37939V21.9794H37.6791V12.5527H34.6051V21.9794H31.5312V12.5527H28.3175V21.9794H25.1504V9.37939H40.8928Z",
    fill: "#1C6947"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7283 9.37939V21.9794H44.1064V9.37939H56.7283ZM53.5146 12.5527H47.3201V18.8527H53.5146V12.5527Z",
    fill: "#1C6947"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0622 12.5527V18.8527H69.3964V21.9793H59.9883V5.31934H63.0622V9.37934H69.3964V12.506H63.0622V12.5527Z",
    fill: "#1C6947"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4381 9.37939V15.5861H79.1778V12.5061H75.7313V21.9794H72.5176V9.37939H82.4381Z",
    fill: "#1C6947"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8543 9.37939V21.9794H85.2324V9.37939H97.8543ZM94.6406 12.5527H88.4461V18.8527H94.6406V12.5527Z",
    fill: "#1C6947"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.596 9.286V21.9793H101.067V5.31934H104.141V9.33267H113.596V9.286ZM110.476 12.5527H104.141V18.7127H110.476V12.5527Z",
    fill: "#1C6947"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.665 9.37939V21.9794H117.043V9.37939H129.665ZM126.451 12.5527H120.257V18.8527H126.451V12.5527Z",
    fill: "#1C6947"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.999 12.5527V18.8527H142.333V21.9793H132.925V5.31934H135.999V9.37934H142.333V12.506H135.999V12.5527Z",
    fill: "#1C6947"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMenu);
export default __webpack_public_path__ + "res/media/logoMenu.0bd9da9adcffcafd72ddedb55a30a68c.svg";
export { ForwardRef as ReactComponent };